/**
 * button-busy.ts — блокировка кнопки/ссылки на время запроса
 */

export function setButtonBusy(el: HTMLElement | null, busy: boolean): void {
  if (!el) return;
  if (busy) {
    el.classList.add('is-busy');
    el.setAttribute('aria-busy', 'true');
    if (el instanceof HTMLButtonElement) {
      el.disabled = true;
    }
  } else {
    el.classList.remove('is-busy');
    el.removeAttribute('aria-busy');
    if (el instanceof HTMLButtonElement) {
      el.disabled = false;
    }
  }
}
